<template>
  <div
    v-if="inputLoading"
    class="tw-animate-pulse tw-rounded-full"
    :class="{ 'tw-size-8 ': !inheritSize }"
  />
  <div v-else class="tw-relative">
    <div
      v-if="avatarUrl && showUserAvatars"
      class="tw-overflow-hidden tw-rounded-full"
      :class="[Classes.AVATAR, inheritSize ? 'tw-size-full' : avatarSize]"
    >
      <object
        :key="avatarUrl"
        :data="avatarUrl"
        type="image/jpeg"
        class="tw-object-cover tw-object-center mod-button-transition tw-size-full tw-pointer-events-none"
      >
        <avatar-icon-fallback
          :user="user"
          :size="size"
          :inherit-size="inheritSize"
          :avatar-size="avatarSize"
        />
      </object>
    </div>

    <avatar-icon-fallback
      v-else
      :user="user"
      :size="size"
      :inherit-size="inheritSize"
      :avatar-size="avatarSize"
    />

    <div
      v-if="showStatus && onlineStatus"
      class="tw-absolute tw-rounded-full tw-border-theme-3"
      :class="[
        Classes.ONLINE_ICON,
        onlineIconStyles,
        onlineStatus ? 'tw-bg-success' : 'tw-bg-grey',
      ]"
    />
  </div>
</template>

<script>
import AvatarIconFallback from '@components/Users/AvatarIconFallback.vue'
import { isOnlineUser } from '@helpers/utils.js'
import Classes from '@shared/js/config/css.js'
import { Settings } from '@config/game.js'
import { computed, toRefs } from 'vue'

export default {
  components: {
    AvatarIconFallback,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['sm', 'md', 'lg', 'xl'].indexOf(value) !== -1
      },
    },
    inputLoading: {
      type: Boolean,
      default: false,
    },
    inheritSize: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { user, size, inheritSize } = toRefs(props)

    const showUserAvatars = computed(() => Settings.value.showUserAvatars)

    const avatarUrl = computed(
      () =>
        user.value &&
        user.value.avatar.thumb_100x100?.search('placeholder/') === -1 &&
        user.value.avatar.thumb_100x100
    )
    const avatarSize = computed(() => {
      if (inheritSize.value) {
        return ''
      } else if (size.value === 'sm') {
        return 'tw-w-7 tw-h-7'
      } else if (size.value === 'lg') {
        return 'tw-w-10 tw-h-10'
      } else if (size.value === 'xl') {
        return 'tw-h-20 tw-w-20 sm:tw-h-28 sm:tw-w-28 '
      }
      return 'tw-w-9 tw-h-9'
    })
    const onlineIconStyles = computed(() => {
      if (size.value === 'xl') {
        return 'tw-h-6 tw-w-6 tw-top-2 tw-right-0 tw-border-2'
      }
      return 'tw-h-3 tw-w-3 tw-top-0.5 tw--right-0.5 tw-border-1.5'
    })
    const onlineStatus = computed(() => isOnlineUser(user.value?.date_online))

    return {
      onlineIconStyles,
      showUserAvatars,
      onlineStatus,
      avatarSize,
      avatarUrl,
      Classes,
    }
  },
}
</script>
